import toString from '../toString';
export default function prefixLines(prefix, value, skipFirst) {
  if (skipFirst === void 0) {
    skipFirst = false;
  }

  return toString(value).split('\n').map(function (line, index) {
    return skipFirst && index === 0 ? line : ''.concat(prefix, line);
  }).join('\n');
}